import React from 'react';
import { connect } from 'react-redux';
import { has } from '../../../services/helper';

function CaravanModel(props) {

    const getModelName = () => {
        const { configuration } = props;
        const { caravan, model } = configuration;
        const caravanName = has(caravan, 'name') ? caravan.name : '';
        return !has(model, 'name') ? caravanName : model.name;
    };

    return (
        <h1>{getModelName()}</h1>
    );

}

const mapStateToProps = state => ({
    configuration: state.configuration,
});

export default connect(mapStateToProps, null)(CaravanModel);
